// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-color-field {
  margin-bottom: 12px;
}

.dp-color-grid {
  display: grid;
  grid-template-columns: 1fr 52px;
  gap: 8px;
  align-items: center;
}

.dp-color-picker {
  width: 52px;
  height: 40px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  box-sizing: border-box;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/properties/fields/ColorField.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".dp-color-field {\n  margin-bottom: 12px;\n}\n\n.dp-color-grid {\n  display: grid;\n  grid-template-columns: 1fr 52px;\n  gap: 8px;\n  align-items: center;\n}\n\n.dp-color-picker {\n  width: 52px;\n  height: 40px;\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  box-sizing: border-box;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
